import ApplicationController from './application_controller'

// data-controller='radio-list' attribute must be declared on the ul.list-group element
export default class extends ApplicationController {

	connect() {
		this.updateHighlight()
	}
	
	updateHighlight(_event) {
		const listItems = Array.from(this.element.querySelectorAll('.list-group-item'))
		listItems.forEach((listItem) => listItem.classList.remove('bg-primary-xlight') )

		const checkedItem = listItems.find((listItem) => listItem.querySelector('input[type="radio"]:checked'))
		if (checkedItem) {
			checkedItem.classList.add('bg-primary-xlight')
		}
	}

}
